<ng-container [formGroup]="subFormGroup">
  <div #personForm>
    <!-- displayed one line input field "2 Erwachsene, 3 Kinder"-->
    <div class="form-line-normal form-placeholder form-placeholder-narrow" (click)="open()">
      <div class="form-icon text-danger">
        <app-icon name="searchPeople" width="20px" height="20px" />
      </div>
      <input
        data-test="search_number_of_people"
        readonly="readonly"
        placeholder=" "
        class="form-input form-input-gray form-input-icon-left c-pointer js-placeholder-trigger js-active-class-toggle"
        id="search_number_of_people"
        name="search_number_of_people"
        type="text"
        value="{{
          adults.value > 0 || children.length > 0
            ? ('ALPINSKIHIRE.shopSearch.formPeopleCount.numberOfPeople'
              | alpitranslate
                : {
                    number_adults: adults.value,
                    pluralizeAdult:
                      'ALPINSKIHIRE.shopSearch.formPeopleCount.adult'
                      | alpitranslate: { pluralate: adults.value },
                    number_children: children.length,
                    pluralizeChildren:
                      'ALPINSKIHIRE.shopSearch.formPeopleCount.child'
                      | alpitranslate: { pluralate: children.length }
                  })
            : ''
        }}"
        (focus)="open()"
        #personCountInput />
      <label class="form-label" for="search_number_of_people">{{
        'ALPINSKIHIRE.shopSearch.formNumberOfPeople' | alpitranslate
      }}</label>
    </div>

    <!-- dropdown element with plus, minus forms -->
    @if (toggleForm) {
      <div class="people-dropdown" @collapsible>
        <!-- adult age add/remove -->
        <div class="row no-gutters mb-2">
          <div class="col-5 col-xl-4">
            <div class="quantity-group js-quantity mr-2">
              <div class="quantity-down btn-primary" (mousedown)="removeAdult()">
                <app-icon name="minus" />
              </div>
              <input
                formControlName="adults"
                #adultInput
                (keyup)="changeAdult()"
                (click)="$any($event.target).select()"
                type="text"
                class="form-input quantity-input js-quantity-input"
                name="search_adults"
                id="search_adults"
                value="{{ adults.value }}" />
              <div data-test="plusIconAdults" class="quantity-up btn-primary" (mousedown)="addAdult()">
                <app-icon name="plus" />
              </div>
            </div>
          </div>
          <div class="col-7 col-xl-8">
            <div class="title">{{ 'ALPINSKIHIRE.shopSearch.formAdultsLabel' | alpitranslate }}</div>
            <p class="description">{{ 'ALPINSKIHIRE.shopSearch.formAdultsLabelInfo' | alpitranslate }}</p>
          </div>
        </div>
        @if (maxAllowedChildren > 0) {
          <!-- child add/remove -->
          <div class="row no-gutters mb-1">
            <div class="col-5 col-xl-4">
              <div class="quantity-group js-quantity mr-2">
                <div class="quantity-down btn-primary" (mousedown)="removeChild()">
                  <app-icon name="minus" />
                </div>
                <input
                  formControlName="numberChildren"
                  (keyup)="changeChild($any($event.target).value)"
                  (click)="$any($event.target).select()"
                  type="text"
                  class="form-input quantity-input js-quantity-input"
                  name="search_children"
                  id="search_children" />
                <div data-test="plusIconChildrens" class="quantity-up btn-primary" (mousedown)="addChild()">
                  <app-icon name="plus" />
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8">
              <div class="title">{{ 'ALPINSKIHIRE.shopSearch.formChildrenLabel' | alpitranslate }}</div>
              <p class="description">{{ 'ALPINSKIHIRE.shopSearch.formChildrenLabelInfo' | alpitranslate }}</p>
            </div>
          </div>
          <!-- child age select boxes -->
          <div class="clearfix" formArrayName="children">
            @if (children.controls.length) {
              <p class="kids-label">
                {{ 'ALPINSKIHIRE.shopSearch.formChildInputLabelInfo' | alpitranslate }}
              </p>
            }
            <div class="children-age-inputs d-flex flex-wrap">
              @for (child of children.controls; track child; let i = $index) {
                <div class="children-age-input">
                  <select
                    data-test="childrenAgeSelect"
                    [formControlName]="i"
                    class="form-control"
                    (change)="updatePersonCount()"
                    [class.border-danger]="child.value === ''">
                    <option
                      value=""
                      selected="selected"
                      label="{{
                        'ALPINSKIHIRE.shopSearch.formChildInputPlaceholder' | alpitranslate
                      }}"></option>
                    <option data-test="childAge1" value="1" label="1">1</option>
                    <option data-test="childAge2" value="2" label="2">2</option>
                    <option data-test="childAge3" value="3" label="3">3</option>
                    <option data-test="childAge4" value="4" label="4">4</option>
                    <option data-test="childAge5" value="5" label="5">5</option>
                    <option data-test="childAge6" value="6" label="6">6</option>
                    <option data-test="childAge7" value="7" label="7">7</option>
                    <option data-test="childAge8" value="8" label="8">8</option>
                    <option data-test="childAge9" value="9" label="9">9</option>
                    <option data-test="childAge10" value="10" label="10">10</option>
                    <option data-test="childAge11" value="11" label="11">11</option>
                    <option data-test="childAge12" value="12" label="12">12</option>
                    <option data-test="childAge13" value="13" label="13">13</option>
                    <option data-test="childAge14" value="14" label="14">14</option>
                    <option data-test="childAge15" value="15" label="15">15</option>
                    <option data-test="childAge16" value="16" label="16">16</option>
                    <option data-test="childAge17" value="17" label="17">17</option>
                  </select>
                </div>
              }
            </div>
            @if (children.invalid && personCountHelper.dirty) {
              <p class="error" @collapsible>
                {{ 'ALPINSKIHIRE.shopSearch.validation.selectAgeForEveryChild' | alpitranslate }}
              </p>
            }
          </div>
        }
        <app-icon name="times" class="close" (click)="toggle()" />
      </div>
    }
  </div>
</ng-container>
